import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'src/auth/context';
import { paths } from 'src/routes/paths';

// NOTE: this is the piece actually missing — AuthProvider correctly clears
// isLpAuthenticated to false (both on initial-load-with-no-session and on a
// mid-session expiry caught by the axios interceptor), but nothing was
// listening to that flag to redirect away from LP-only pages. Wrap any
// LP-only route element with this instead of rendering it directly.
//
// Usage in LiquidityProviderRoutesLazy:
//   { path: 'dashboard', element: <LPAuthGuard><LPDashboardPage /></LPAuthGuard> }

export default function LPAuthGuard({ children }) {
  const { loading, isLpAuthenticated } = useContext(AuthContext);
  console.log('isLpAuthenticated', isLpAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    // Wait until the initial session bootstrap (or a later re-sync) has
    // actually resolved — redirecting while `loading` is still true would
    // fire on every fresh page load before AuthProvider has had a chance to
    // confirm one way or the other.
    if (loading) return;

    if (!isLpAuthenticated) {
      navigate(paths.lp.login, { replace: true });
    }
  }, [loading, isLpAuthenticated, navigate]);

  if (loading || !isLpAuthenticated) {
    return null;
  }

  return children;
}

LPAuthGuard.propTypes = {
  children: PropTypes.node,
};
